"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _searchDateTimeForm = require("./search-date-time-form");
var _dropdownBtn = require("../dropdown-btn");
var _inputGroupAddon = require("../input-group-addon");
var _searchDateTimeHoc = _interopRequireDefault(require("./search-date-time-hoc"));
var _moment = _interopRequireDefault(require("moment"));
var _reactIntl = require("react-intl");
var _excluded = ["selectedDate", "selectedDateString", "inputRef", "buttonClassName", "defaultLabel", "containerClassName", "openOnLoad"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var SearchDateTimeButton = /*#__PURE__*/function (_React$Component) {
  _inherits(SearchDateTimeButton, _React$Component);
  function SearchDateTimeButton(props) {
    var _this;
    _classCallCheck(this, SearchDateTimeButton);
    _this = _callSuper(this, SearchDateTimeButton, [props]);
    _this.dropDownBtn = null;
    return _this;
  }
  _createClass(SearchDateTimeButton, [{
    key: "close",
    value: function close() {
      if (this.dropDownBtn.hideDropDown) {
        this.dropDownBtn.hideDropDown(); // Call the method exposed by DropDownBtn
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        selectedDate = _this$props.selectedDate,
        selectedDateString = _this$props.selectedDateString,
        inputRef = _this$props.inputRef,
        buttonClassName = _this$props.buttonClassName,
        defaultLabel = _this$props.defaultLabel,
        containerClassName = _this$props.containerClassName,
        openOnLoad = _this$props.openOnLoad,
        rest = _objectWithoutProperties(_this$props, _excluded);
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_inputGroupAddon.InputAddOn, {
        leftAddon: this.props.addOnImage
      }, /*#__PURE__*/_react.default.createElement(_dropdownBtn.DropDownBtn, {
        ref: function ref(_ref) {
          _this2.dropDownBtn = _ref;
        },
        onHideFn: this.props.onHideFn,
        mobileViewOff: true,
        openOnLoad: openOnLoad,
        buttonId: "search-date-time-btn",
        containerClassName: containerClassName,
        buttonClassName: "remove-click-styling search-date-dropdown ".concat(buttonClassName),
        buttonChildren: /*#__PURE__*/_react.default.createElement("div", {
          className: "ellipsis"
        }, this.props.displayDateTime || defaultLabel || /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
          id: "shared_components.search_date_time_button.default_label",
          defaultMessage: "When?"
        }))
      }, /*#__PURE__*/_react.default.createElement(_searchDateTimeForm.DateTimeForm, _extends({}, rest, {
        selectedDate: selectedDate,
        dateColClass: "border-right",
        intl: this.props.intl
      })))), /*#__PURE__*/_react.default.createElement("input", {
        ref: function ref(_ref2) {
          if ('function' === typeof inputRef) inputRef(_ref2);
        },
        type: "hidden",
        readOnly: true,
        "data-value": selectedDateString,
        value: selectedDate ? (0, _moment.default)(selectedDate).format('ll') : ''
      }));
    }
  }]);
  return SearchDateTimeButton;
}(_react.default.Component);
SearchDateTimeButton.propTypes = {
  dropDownBtnRef: _propTypes.default.func,
  onHideFn: _propTypes.default.func,
  displayDateTime: _propTypes.default.string,
  addOnImage: _propTypes.default.element,
  selectedDate: _propTypes.default.string,
  selectedDateString: _propTypes.default.string,
  inputRef: _propTypes.default.func,
  buttonClassName: _propTypes.default.string,
  defaultLabel: _propTypes.default.string
};
var _default = exports.default = (0, _searchDateTimeHoc.default)(SearchDateTimeButton);